// SemanticUI-free pre-@plone/components
import { Container } from '@plone/components';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import MobileNavigation from '../MobileNavigation/MobileNavigation';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Logo from '@plone/volto/components/theme/Logo/Logo';
// import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import Navigation from '../Navigation/Navigation';
// Import SVGs as standard imports
// import Icon from '@plone/volto/components/theme/Icon/Icon';
import config from '@plone/volto/registry';
import facebookIcon from '../../assets/icons/facebook.svg';
import flickrIcon from '../../assets/icons/flickr.svg';
import instagramIcon from '../../assets/icons/instagram.svg';
import megaphoneIcon from '../../assets/icons/megaphone.svg';
import telegramIcon from '../../assets/icons/telegram.svg';
import tiktokIcon from '../../assets/icons/tiktok.svg';
import twitterIcon from '../../assets/icons/twitter.svg';
import youtubeIcon from '../../assets/icons/youtube.svg';
import { PORTAL_CANDIDAT_URL } from '../../contants/routes';
import Icon from '../Icon/Icon';

const PORTAL_CANDIDAT_DESCRIPTION =
  'Un espai temporal amb recursos i informació per a la precampanya i campanya.';

const InternetHeader = ({ pathname }) => {
  // TODO; les actions no es mostren, ja que no hi ha permis quan no estas logejat. Revisar pagina 404 i buscar mateix approach
  const headerSettings = useSelector(
    (state) =>
      state.content.data?.['@components']?.inherit?.['voltolighttheme.header']
        ?.data,
  );
  const formData = useSelector((state) => state.form.global);
  const headerActions =
    !isEmpty(formData) && formData?.header_actions
      ? formData.header_actions
      : headerSettings?.header_actions;
  const items = useSelector((state) => state.navigation.items);
  const lang = useSelector((state) => state.intl.locale);
  const { settings } = config;

  const portalCandidatItem = items?.find(
    (item) => item.url === PORTAL_CANDIDAT_URL,
  );
  const portalCandidatChildren = portalCandidatItem?.items ?? [];
  const portalCandidatLabel =
    portalCandidatItem?.nav_title || portalCandidatItem?.title;
  const portalCandidatDescription =
    portalCandidatItem?.description || PORTAL_CANDIDAT_DESCRIPTION;
  const hasPortalCandidatSubmenu = portalCandidatChildren.length > 0;
  const hasPortalCandidatActive = pathname.includes(PORTAL_CANDIDAT_URL);
  return (
    <>
      <nav className="top-menu-wrapper">
        <div className="top-menu">
          <ul className="social-media-links-wrapper">
            {portalCandidatItem && (
              <li>
                <NavLink
                  to={
                    portalCandidatItem.url === '' ? '/' : portalCandidatItem.url
                  }
                  key={portalCandidatItem.url}
                  className="item btn-portal-candidat"
                  exact={
                    settings.isMultilingual
                      ? portalCandidatItem.url === `/${toBackendLang(lang)}`
                      : portalCandidatItem.url === ''
                  }
                >
                  {portalCandidatLabel}
                </NavLink>
              </li>
            )}
            <li>
              <a
                href="https://www.facebook.com/JxCatalunya/"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={facebookIcon} size="1rem" />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/juntsxcat"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={twitterIcon} size="1rem" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/juntspercat/"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={instagramIcon} size="1rem" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UCG6dZxszooC9hpNRr1-LlJw"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={youtubeIcon} size="1rem" />
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/@juntspercat"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={tiktokIcon} size="1rem" />
              </a>
            </li>
            <li>
              <a
                href="https://www.flickr.com/photos/juntsxcat"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={flickrIcon} size="1rem" />
              </a>
            </li>
            <li>
              <a
                href="https://t.me/juntsxcat"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link"
              >
                <Icon name={telegramIcon} size="1rem" />
              </a>
            </li>
          </ul>
          {headerActions &&
            Array.isArray(headerActions) &&
            headerActions.length > 0 && (
              <ul className="tools">
                {headerActions &&
                  Array.isArray(headerActions) &&
                  headerActions.map((item) => (
                    <li key={item['@id']}>
                      <UniversalLink href={item.href?.[0]['@id']}>
                        {item.title}
                      </UniversalLink>
                    </li>
                  ))}
              </ul>
            )}
        </div>
      </nav>
      <div className="header">
        <div className="logo-nav-wrapper">
          <div className="logo">
            <Logo />
          </div>
          <Navigation pathname={pathname} />
          <MobileNavigation pathname={pathname} />
          <div className="search-wrapper navigation-desktop">
            <div className="search">
              <SearchWidget />
            </div>
          </div>
        </div>
      </div>
      {hasPortalCandidatActive && portalCandidatItem && (
        <>
          <div className="portal-candidat-subheader-wrapper">
            <div className="portal-candidat-subheader">
              <Icon
                name={megaphoneIcon}
                size="2.5rem"
                className="portal-candidat-subheader-icon"
                ariaHidden
              />
              <div className="portal-candidat-subheader-title">
                {portalCandidatLabel}
              </div>
              <p className="portal-candidat-subheader-description">
                {portalCandidatDescription}
              </p>
            </div>
          </div>
          {hasPortalCandidatSubmenu && (
            <nav
              className="portal-candidat-submenu-wrapper"
              aria-label={portalCandidatLabel}
            >
              <ul className="portal-candidat-submenu">
                {portalCandidatChildren.map((child) => (
                  <li key={child.url}>
                    <NavLink
                      to={child.url === '' ? '/' : child.url}
                      className="item"
                      activeClassName="active"
                    >
                      {child.nav_title || child.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </>
      )}
    </>
  );
};

const Header = (props) => {
  const { pathname } = props;
  const content = useSelector((state) => state.content.data);
  const navRoot = useSelector((state) => state.navroot?.data?.navroot);
  return (
    <>
      <SlotRenderer name="aboveHeader" content={content} navRoot={navRoot} />
      <header className="header-wrapper">
        <Container>
          <InternetHeader pathname={pathname} />
        </Container>
      </header>
    </>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
};

Header.defaultProps = {
  token: null,
};

export default Header;
